import { InvitationScreen } from '@avrahami/ui';
import { Link } from '@tanstack/react-router';
import { passwordResetApi } from '../api/session';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/format';

/** Public page behind a mailed "forgot password" link: sets a new password (adr/0035). */
export function ResetPasswordPage() {
  return (
    <InvitationScreen
      product={he.app.product}
      words={he.passwordReset}
      inspect={passwordResetApi.inspect}
      accept={passwordResetApi.complete}
      errorText={errorMessage}
      loginLink={
        <Link to="/login" search={{}} className="text-center text-brand-700 underline">
          {he.passwordReset.goToLogin}
        </Link>
      }
    />
  );
}
